(function () {
  const DURATION_MS = 260;
  const EASING = 'ease';

  function animateAccordion(details) {
    if (details.dataset.accordionAnimated === 'true') return;

    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    details.dataset.accordionAnimated = 'true';
    let isAnimating = false;

    summary.addEventListener('click', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      event.preventDefault();
      if (isAnimating) return;
      isAnimating = true;

      content.style.overflow = 'hidden';
      content.style.transition = `height ${DURATION_MS}ms ${EASING}`;

      if (!details.open) {
        details.open = true;
        content.style.height = '0px';
        requestAnimationFrame(() => {
          content.style.height = `${content.scrollHeight}px`;
        });

        const onOpenEnd = () => {
          content.style.height = 'auto';
          content.style.overflow = '';
          content.style.transition = '';
          isAnimating = false;
          content.removeEventListener('transitionend', onOpenEnd);
        };
        content.addEventListener('transitionend', onOpenEnd);
      } else {
        content.style.height = `${content.scrollHeight}px`;
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });

        const onCloseEnd = () => {
          details.open = false;
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
          isAnimating = false;
          content.removeEventListener('transitionend', onCloseEnd);
        };
        content.addEventListener('transitionend', onCloseEnd);
      }
    });
  }

  function initMainProductAccordions(root) {
    root.querySelectorAll('.product__accordion details').forEach(animateAccordion);
  }

  document.addEventListener('DOMContentLoaded', () => initMainProductAccordions(document));
  document.addEventListener('shopify:section:load', (event) => initMainProductAccordions(event.target));
})();
